import React from 'react';
import classNames from 'classnames';
import style from './Plans/Plan.module.scss';
import { getPriceBlock } from './Price';
import { IPlan } from '../model';

interface IProps{
  plan: IPlan;
  yearly: boolean;
  isAdditional?: boolean;
  className?: string;
}

export const CurrentBadge = ({plan, yearly, isAdditional, ...props}: IProps) => {
  let mainPlan = isAdditional ? plan.additional : plan;
  if (!mainPlan) return null;
  if (!mainPlan.current) return null;
  const currentPrice = mainPlan?.current?.price;
  if (yearly) {
    if (mainPlan.current.interval === 'year') {
      return <div className={classNames(style.current_plan_top, style.without_price, props.className)}>
        <h5>Your Current Plan</h5>
      </div>
    }
    if (mainPlan.current.interval === 'month') {
      return <div className={classNames(style.current_plan, props.className)}>
        <h5>Current Plan</h5>
        <div className={style.current_plan_different}>
          <div className={style.current_plan_left}>
            {mainPlan?.display?.name} <span className={style.current_plan_period}>monthly</span>
          </div>
          <div className={style.cost}>
            <div className={style.price}>
              {getPriceBlock(Number(currentPrice))}<sub>/mo</sub>
            </div>
          </div>
        </div>
      </div>
    }
  } else {
    if (mainPlan.current.interval === 'year') {
      return <div className={classNames(style.current_plan, props.className)}>
        <h5>Current Plan</h5>
        <div className={style.current_plan_different}>
          <div className={style.current_plan_left}>
            {mainPlan?.display?.name} <span className={style.current_plan_period}>yearly</span>
          </div>
          <div className={style.cost}>
            <div className={style.price}>
              {getPriceBlock(Number(currentPrice) / 12)}<sub>/mo</sub>
            </div>
          </div>
        </div>
      </div>
    }
    if (mainPlan.current.interval === 'month') {
      return <div className={classNames(style.current_plan_top, style.without_price, props.className)}>
        <h5>Your Current Plan</h5>
      </div>
    }
  }
  return null;
}
